export enum FuzzyAppointmentTimes {
  Morning = 'morning',
  Evening = 'evening',
  Afternoon = 'afternoon'
}
